import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { AccessControlPermissionTypesFilters } from '../../types';
import { useTranslation } from 'react-i18next';

export interface AccessControlPermissionTypesFiltersBoxProps {
  filtersForm: UseFormReturn<AccessControlPermissionTypesFilters>;
}

export const AccessControlPermissionTypesFiltersBox = ({ filtersForm }: AccessControlPermissionTypesFiltersBoxProps) => {
  const { register, reset } = filtersForm;
  const { t } = useTranslation();

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle' fontWeight='semibold'>
          {t('pages.access_control_permission_types.components.filter_box.heading')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'column' }} gap='small' rowGap='micro'>
        <SimpleGrid gap='deka' alignItems='flex-end' columns={{ base: 1, md: 4, xl: 6, '10xl': 6 }} rowGap='xxsmall' flexGrow={1}>
          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>{t('pages.access_control_permission_types.components.filter_box.label_name')}</Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('name'))} />
          </InputGroup>
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.access_control_permission_types.components.filter_box.button_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
